import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export function BottomSheet({ open, onClose, eyebrow, title, children, testId, maxW = "max-w-lg" }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/40 md:items-center md:p-6" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose}>
          <motion.div data-testid={testId} initial={{ y: 80 }} animate={{ y: 0 }} exit={{ y: 80 }} transition={{ type: "spring", damping: 26, stiffness: 300 }} onClick={(e) => e.stopPropagation()}
            className={`max-h-[92vh] w-full ${maxW} overflow-y-auto rounded-t-3xl bg-[var(--parchment)] p-5 md:rounded-3xl`} style={{ maxHeight: "92dvh", paddingBottom: "calc(1.25rem + env(safe-area-inset-bottom))", WebkitOverflowScrolling: "touch" }}>
            <div className="flex items-start justify-between">
              <div>{eyebrow && <p className="eyebrow">{eyebrow}</p>}{title && <h2 className="font-display text-2xl font-semibold leading-tight">{title}</h2>}</div>
              <button data-testid={`${testId}-close`} onClick={onClose} className="tap rounded-full bg-white p-2"><X className="h-4 w-4" /></button>
            </div>
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export const Field = ({ label, children }) => <label className="block"><span className="eyebrow">{label}</span>{children}</label>;
export const inputCls = "mt-1 w-full rounded-xl border bg-white px-3 py-2.5 text-base";
